import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import Widget from "./Widgets";
import RecentOrders from "./RecentOrders";
import RecentCustomers from "./RecentCustomers";
import TransactionsList from "./TransactionsList";
import DailyDeliveryOverview from "./DailyDeliveryOverview";
import PausedSubscriptions from "./PausedSubscriptions";
import ExpiringSubscriptions from "./ExpiringSubscriptions";


const DashboardEcommerce = () => {
  document.title = "Paal Dappa | Admin Panel";
  console.log("DD:DashboardEcommerce rendered");

  useEffect(() => {
    console.log("Component mounted (similar to componentDidMount)");

  }, []); // Runs once on mount
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row>
                  <Widget />
                </Row>
                <Row>
                  <DailyDeliveryOverview />
                </Row>
                <Row id="expiring-subscriptions-section">
                  <ExpiringSubscriptions />
                </Row>
                <Row id="paused-subscriptions-section">
                  <PausedSubscriptions />
                </Row>
                <Row>
                  <RecentOrders />
                </Row>
                <Row>
                  <RecentCustomers />
                </Row>

                <Row>
                  <TransactionsList />
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
